<div class="inner-content">

  <p class="SCWEB-header-text">Summary of Charges</p>

  <div id="breakdown-wrapper" *ngIf="cost">
    <cost-breakdown [promoCode]="promoCode" [cost]="cost" [selectedServiceTypeList]="selectedServiceTypeList">
    </cost-breakdown>
  </div>

</div>